import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  UserData,UpPass
} from "../../model/model";
import SessionStore from "../../model/SessionStore";
import PasswordForm from "./PasswordForm";

function ChangeUserPassword() {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [userData, setUser] = useState<UserData | undefined>(undefined);

  useEffect(() => {
    const req :string  = userId!;
 
    SessionStore.getClient().getUser(req, SessionStore.getBearer()).then((resp) => {
      setUser(resp.data);
    });
  }, [userId]);

  const onFinish = (pw: string) => {
    const req :UpPass = {
      login: userId!, pass: pw
    }
    SessionStore.getClient().updatePassword(req, SessionStore.getBearer()).then(() => {
      navigate("/");
    });
  };

  if (!userData) {
    return null;
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Users</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>{userData.email}</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Change password</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title={userData.email}
        subTitle={`userData id: ${userData.login}`}
      />
      <Card>
        <PasswordForm onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default ChangeUserPassword;
